import { useTranslation } from 'react-i18next'
import type { MeetingManagementTask } from '../types'

interface Props {
  row: MeetingManagementTask
  onOpenFiles: (row: MeetingManagementTask) => void
}

/**
 * Satırın **ataç** göstergesi (105/FR-051) — tablo ve kart dalının **ortak** hücresi.
 *
 * <p><b>Ataç varsa dosya vardır, yoksa hiçbir şey çizilmez</b> (kullanıcı kuralı 30.09.2026): boş
 * durumda soluk bir ikon ya da "—" bırakmak, "dosya yok" ile "dosya var ama yetkin yok" ayrımını
 * bulanıklaştırırdı — kolonun tek anlamı budur.
 *
 * <p><b>Gerçek bir {@code <button>}</b>, tıklanabilir bir ikon değil: klavyeyle ulaşılabilir olması
 * ve ekran okuyucunun bunu bir işlem olarak duyurması gerekiyor. Erişilebilir ad **görev adıyla**
 * kurulur — sayfada onlarca özdeş "Dosyalar" düğmesi, sesli kontrol kullanıcısının satırları
 * ayırmasını imkânsız kılardı (tablonun seçim kutusuyla aynı ilke).
 */
export default function AttachmentCell({ row, onOpenFiles }: Readonly<Props>) {
  const { t } = useTranslation()
  if (!row.hasAttachment) {
    return null
  }
  return (
    <button
      type="button"
      className="mm-attach-btn"
      onClick={() => onOpenFiles(row)}
      aria-label={t('meetingManagement.files.openNamed', { name: row.name })}
      title={t('meetingManagement.files.open')}
    >
      <i className="pi pi-paperclip" aria-hidden="true" />
    </button>
  )
}
